import { render, staticRenderFns } from "./delete.vue?vue&type=template&id=490e7d2a&"
import script from "./delete.vue?vue&type=script&lang=ts&"
export * from "./delete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports